(function () {
  // ---- click anywhere on a card (except the add button) opens the product ----
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-rmc-add]');
    if (addBtn) return; // handled separately below
    var card = e.target.closest('[data-rmc-href]');
    if (!card) return;
    if (e.target.closest('a, button, input, label, [data-rmc-no-nav]')) return;
    window.location.href = card.dataset.rmcHref;
  });

  // ---- "+" button: real add to cart ----
  function notifyCartUpdate(itemCount) {
    try {
      var evt = new Event('shopify:cart:lines-update', { bubbles: true });
      evt.action = 'add';
      evt.promise = Promise.resolve({ detail: { itemCount: itemCount } });
      document.dispatchEvent(evt);
    } catch (err) {
      /* older browsers: cart icon just won't animate, no functional impact */
    }
  }

  // Shopify's cart endpoints normally return a JSON error body even when
  // something's rejected (sold out, invalid variant, etc.) — but they can
  // occasionally hand back a plain HTML error page instead (a stale/deleted
  // variant ID from a page that loaded before this catalog's frequent
  // backend resync touched it, a transient edge/CDN error, and so on).
  // Calling res.json() directly on that throws a raw "Unexpected token '<'"
  // parse error, which is not something a customer should ever see. This
  // tries the real error message first and always falls back to something
  // normal instead of letting that parse error escape.
  function safeErrorMessage(res) {
    return res
      .json()
      .then(function (data) { return data.message || 'Could not add this item to your cart. Please refresh the page and try again.'; })
      .catch(function () { return 'Could not add this item to your cart. Please refresh the page and try again.'; });
  }

  // Same non-JSON-response risk as safeErrorMessage above, but for a
  // response that already reported res.ok (or one read before an ok check
  // even happens, like the /cart.js read below) — confirmed live: a
  // customer saw the raw "Unexpected token '<', "<!doctype "... is not
  // valid JSON" parse error itself, from a res.json() call this file never
  // wrapped. Rejects with a normal message instead of letting that escape.
  function safeJson(res) {
    return res.json().catch(function () {
      throw new Error('Something went wrong reaching the cart. Please refresh the page and try again.');
    });
  }

  // ---- keep each card's add-button / quantity-stepper in sync with what's
  // actually in the cart, so a customer can tell what they've added without
  // opening the cart drawer ----
  function qtyMapFromCart(cart) {
    var map = {};
    cart.items.forEach(function (item) {
      map[item.variant_id] = (map[item.variant_id] || 0) + item.quantity;
    });
    return map;
  }

  function setControlQty(control, qty) {
    var addBtn = control.querySelector('[data-rmc-add]');
    var stepper = control.querySelector('[data-rmc-stepper]');
    var qtyEl = control.querySelector('[data-rmc-stepper-qty]');
    control.dataset.rmcQty = qty;
    if (qty > 0) {
      if (addBtn) addBtn.hidden = true;
      if (stepper) stepper.hidden = false;
      if (qtyEl) qtyEl.textContent = qty;
    } else {
      if (addBtn) addBtn.hidden = false;
      if (stepper) stepper.hidden = true;
    }
  }

  function syncCardsWithCart() {
    var controls = Array.prototype.slice.call(document.querySelectorAll('[data-rmc-cart-controls]'));
    if (!controls.length) return;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var qtyByVariant = qtyMapFromCart(cart);
        controls.forEach(function (control) {
          setControlQty(control, qtyByVariant[control.dataset.variantId] || 0);
        });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rmc-add]');
    if (!btn) return;

    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    var control = btn.closest('[data-rmc-cart-controls]');

    // The delivery day the customer picked (reset-delivery-calendar.js) is
    // already saved as a cart attribute — read it from the cart itself
    // rather than the page's own DOM, since the day-selector widget isn't
    // present on every page this add-to-cart button appears on. Attaching
    // it as a line item property (not just a cart attribute) is what makes
    // it show up automatically in Shopify's checkout order summary.
    fetch('/cart.js', { cache: 'no-store' })
      .then(safeJson)
      .then(function (cart) {
        var deliveryDate = cart.attributes && cart.attributes['Delivery Date'];
        var item = { id: variantId, quantity: 1 };
        if (deliveryDate) item.properties = { 'Delivery Date': deliveryDate };
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
      })
      .then(function (res) {
        if (!res.ok) return safeErrorMessage(res).then(function (message) { throw new Error(message); });
        return safeJson(res);
      })
      .then(function () {
        btn.disabled = false;
        btn.setAttribute('data-added', 'true');
        setTimeout(function () {
          btn.removeAttribute('data-added');
        }, 2000);

        // The add button only ever shows while this variant's cart quantity
        // is 0, so a successful add always brings it to 1 — update the card
        // immediately instead of waiting on a second round trip to /cart.js.
        if (control) setControlQty(control, 1);

        // Refresh the header badge / other listeners in the background —
        // doesn't block the card's own UI, which already updated above.
        fetch('/cart.js', { cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { notifyCartUpdate(cart.item_count); })
          .catch(function () {});
      })
      .catch(function (err) {
        btn.disabled = false;
        alert(err.message || 'Could not add this item to your cart. Please try again.');
      });
  });

  // ---- stepper +/- on a card: adjust the quantity of an item already in the cart ----
  function changeQty(control, newQty) {
    var variantId = control.dataset.variantId;
    var stepper = control.querySelector('[data-rmc-stepper]');
    if (stepper) stepper.setAttribute('data-busy', 'true');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: newQty })
    })
      .then(function (res) {
        if (!res.ok) return safeErrorMessage(res).then(function (message) { throw new Error(message); });
        return safeJson(res);
      })
      .then(function (cart) {
        if (stepper) stepper.removeAttribute('data-busy');
        setControlQty(control, qtyMapFromCart(cart)[variantId] || 0);
        notifyCartUpdate(cart.item_count);
      })
      .catch(function (err) {
        if (stepper) stepper.removeAttribute('data-busy');
        alert(err.message || 'Could not update your cart. Please try again.');
      });
  }

  document.addEventListener('click', function (e) {
    var minusBtn = e.target.closest('[data-rmc-stepper-minus]');
    var plusBtn = e.target.closest('[data-rmc-stepper-plus]');
    if (!minusBtn && !plusBtn) return;

    var control = (minusBtn || plusBtn).closest('[data-rmc-cart-controls]');
    if (!control) return;
    var stepper = control.querySelector('[data-rmc-stepper]');
    if (stepper && stepper.hasAttribute('data-busy')) return;

    var currentQty = parseInt(control.dataset.rmcQty, 10) || 0;
    var newQty = minusBtn ? Math.max(0, currentQty - 1) : currentQty + 1;
    changeQty(control, newQty);
  });

  syncCardsWithCart();
  document.addEventListener('shopify:cart:lines-update', syncCardsWithCart);
  document.addEventListener('shopify:cart:update', syncCardsWithCart);
})();
